import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const NortheastPage = () => {
  return <DestinationTemplate destinationId="northeast" />;
};

export default NortheastPage;
